exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-mortgage-properties[data-v-6d40981d] {\n  position: relative;\n  margin-bottom: 15px;\n}\n.create-button[data-v-6d40981d] {\n  margin-top: 15px;\n}\n", ""]);

// exports
